import { createSlice } from '@reduxjs/toolkit';

export const commandPaletteSlice = createSlice({
  name: 'commandPalette',
  initialState: {
    isOpen: false,
  },
  reducers: {
    setCommandPaletteOpen: (state, action) => {
      state.isOpen = action.payload;
    },
  },
});

export const { setCommandPaletteOpen } = commandPaletteSlice.actions;

export default commandPaletteSlice.reducer;
